/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Recover_ErrorInputs */



/**
* | output |
* | --- |
* | "An error occurred while attempting to recover the account. Please try again." |
*
* @param {Auth_Recover_ErrorInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const auth_recover_error = /** @type {((inputs?: Auth_Recover_ErrorInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Recover_ErrorInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Ein Fehler ist bei der Wiederherstellung des Kontos aufgetreten. Bitte versuche es erneut.")
	return /** @type {LocalizedString} */ ("An error occurred while attempting to recover the account. Please try again.")
});